package com.shadowings.gero.data.lessons.chapter9

import com.shadowings.gero.data.lessons.inlineMeaning
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.ImageKeyboardContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_vocab_vari_2_alyn
import gero.composeapp.generated.resources.exp_content_vocab_vari_2_cielo
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_vocab_vari_2_intro
import gero.composeapp.generated.resources.exp_title_word_name

val vocabVari2WordIds = listOf("PALAZZO", "FIUME", "DESERTO", "CIELO", "NAVE", "PORTA")

fun getVocabVari2Content(words: List<Word>, languageCode: String): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.exp_title_vocab_vari_2_intro,
            content = Res.string.exp_content_vocab_vari_2_alyn,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )

    val slides = vocabVari2WordIds
        .mapNotNull { id -> words.firstOrNull { it.id == id } }
        .map { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                character = Characters.Nilo,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }

    return intro + slides
}

// Inscription photo (image code, word id, caption) with the word highlighted by a red box.
private val vocabVari2Inscriptions = listOf(
    Triple("cielo", "CIELO", Res.string.exp_content_vocab_vari_2_cielo),
)

fun getVocabVari2QuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val vocabQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode,
        additionalOptions = vocabVari1WordIds.toSet()
    )
    val inscriptionQuizzes = vocabVari2Inscriptions.mapNotNull { (imageCode, wordId, caption) ->
        val word = words.firstOrNull { it.id == wordId } ?: return@mapNotNull null
        ImageKeyboardContent(
            imageCode = imageCode,
            reading = word.reading.lowercase().map { it.toString() },
            translation = caption
        )
    }
    return (vocabQuizzes + inscriptionQuizzes).shuffled()
}
